import { render, staticRenderFns } from "./month-detail.vue?vue&type=template&id=59321268"
import script from "./month-detail.vue?vue&type=script&lang=js"
export * from "./month-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports